export const Breakpoints = {
  mobile: 520,
  tablet: 768,
  smallDesktop: 1024,
}
